import type { DoorTypeId } from '@planner/config';
import { evaluateLockFit } from '@planner/shared/doors';
import type { LockDraft } from '../stores/doorStore.js';
import { parseMillimetres, type MeasurementsEvaluation } from './measurements.js';

export type LockHeightError = 'required' | 'invalid' | 'out-of-range' | 'clearance';

export interface LockEvaluation {
  heightError: LockHeightError | undefined;
  sideError: 'required' | undefined;
  canContinue: boolean;
}

export function evaluateLock(
  lock: LockDraft,
  doorType: DoorTypeId | null,
  measurements: Pick<MeasurementsEvaluation, 'size' | 'canContinue'>,
): LockEvaluation {
  const height = parseMillimetres(lock.height);
  let heightError: LockHeightError | undefined =
    height === undefined ? (lock.height.trim() ? 'invalid' : 'required') : undefined;
  const fit =
    height !== undefined && doorType && measurements.size
      ? evaluateLockFit(height, doorType, measurements.size.height)
      : undefined;
  if (fit && fit.status !== 'valid') {
    heightError = fit.status;
  }
  const sideError = lock.side === null ? 'required' : undefined;
  return {
    heightError,
    sideError,
    canContinue: measurements.canContinue && fit?.status === 'valid' && sideError === undefined,
  };
}
